import { render, staticRenderFns } from "./TripsGrid.vue?vue&type=template&id=06a77f46&scoped=true&"
import script from "./TripsGrid.vue?vue&type=script&lang=ts&"
export * from "./TripsGrid.vue?vue&type=script&lang=ts&"
import style0 from "./TripsGrid.vue?vue&type=style&index=0&id=06a77f46&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06a77f46",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VFlex } from 'vuetify/lib/components/VGrid';
installComponents(component, {VFlex})
